import axios from 'axios';
import React, { useEffect, useState } from 'react';
import AddPetDetails from './AddPetDetails';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from "uuid";
import config from "../config";
const aws = require("aws-sdk");

const EditPet = () => {
  const [pets, setPets] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const API_BASE_URL = config.API_BASE_URL;


const fetchPets = async () => {
  try {
    const token = localStorage.getItem("token"); 
    const response = await axios.post(
      `${API_BASE_URL}/customer/getallpet`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
   
  } catch (error) {
    console.error("Error fetching pet data:", error.response?.data || error);
  }
};


  useEffect(() => {
    fetchPets();
  }, []);

  const calculateAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    const d = today.getDate() - birth.getDate();
    if (m < 0 || (m === 0 && d < 0)) age--;
    return age > 0 ? `${age} year${age > 1 ? 's' : ''}` : `${m + (d < 0 ? -1 : 0)} month(s)`;
  };

  const handleChange = (index, field, value) => {
    const updated = [...pets];
    updated[index][field] = value;
    setPets(updated);
  };

  const handleImageUpload = async (e) => {
    try {
      const file = e.target.files[0];
      const ext = file.name.split('.').pop();
      const s3 = new aws.S3({
        accessKeyId: config.AWS_KEY_ID,
        secretAccessKey: config.AWS_SECRET_KEY,
      });

      const params = {
        Bucket: "finlocalpetchat",
        Key: `${uuidv4()}.${ext}`,
        Body: file,
        ContentType: file.type,
      };

      const { Location } = await s3.upload(params).promise();
      setImageUrl(Location);
      return Location;
    } catch (err) {
      console.error(err);
      return null;
    }
  };

  const handleSave = async (id, pet) => {
    const birthday = pet.pet_bday.split('T')[0] || "";
    const updatedPet = {
      ...pet,
      pet_bday: birthday,
      age: calculateAge(birthday),
      vaccination_docs: imageUrl || pet.vaccination_docs,
    };
    delete updatedPet._id;
    delete updatedPet.__v;
    delete updatedPet.customerId;
    delete updatedPet.personalityInfo;
    delete updatedPet.vaccination_docsName;

    try {
      const res = await axios.put(`${API_BASE_URL}/customer/updatepet/${id}`, updatedPet);
      if (res.status === 200) {
        toast.success("Pet updated successfully", { position: "top-center" });
        fetchPets();
      } else {
        toast.error("Failed to save pet data", { position: "top-center" });
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      {/* UI rendering would go here */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-3xl h-4/5 overflow-y-auto">
            <AddPetDetails onClose={() => { setIsModalOpen(false); fetchPets(); }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default EditPet;
